/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsUpdateMutationRequest, StationsStationsUpdateMutationResponse, StationsStationsUpdatePathParams } from "../models/StationsStationsUpdate";

export function getStationsStationsUpdateUrl(station: StationsStationsUpdatePathParams["station"]) {
  const res = { method: 'PUT', url: `/stations/v1/${station}` as const }
  return res
}

/**
 * @description Updates station properties such as name, language, and timezone.
 * @summary Update station
 * {@link /stations/v1/:station}
 */
export async function stationsStationsUpdate(station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest, config: Partial<RequestConfig<StationsStationsUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, StationsStationsUpdateMutationRequest>({ method : "PUT", url : getStationsStationsUpdateUrl(station).url.toString(), data : requestData, ... requestConfig })
  return res.data
}